module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.element && ['product_image', 'redirect_link'].indexOf(_vm.type) !== -1) ? _c('ElementHighlighter', {
    attrs: {
      "type": _vm.type,
      "element": _vm.element,
      "definition": _vm.definition,
      "classes": _vm.classes,
      "selected": _vm.selected,
      "active": _vm.active,
      "disabled": _vm.disabled
    }
  }) : (_vm.element) ? _c('TextHighlighter', {
    attrs: {
      "type": _vm.type,
      "element": _vm.element,
      "definition": _vm.definition,
      "classes": _vm.classes,
      "selected": _vm.selected,
      "active": _vm.active,
      "disabled": _vm.disabled
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e8efe3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/Highlighter.vue
// module id = FbI0
// module chunks = 1